module.exports = "/images/reciteme_button_dark.png?0e0ef2f0fa99495f545341a0321bd7d4";